"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = exports.closeHistory = exports.captureGlobalClick = void 0;
var _reduxActions = require("redux-actions");
var _connectedReactRouter = require("connected-react-router");
var _last2 = _interopRequireDefault(require("lodash/last"));
var _cccisdLaravelEventlog = require("cccisd-laravel-eventlog");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// If user has been staying on the page less than this time, then don't save it in url history
var limitTime = 500;

// Initial state
var initialState = {
  urlHistory: [],
  globalClickCaptured: false
};

// Actions
exports.initialState = initialState;
var CLOSE_HISTORY = 'boilerplate/boilerplate/CLOSE_HISTORY';
var CAPTURE_GLOBAL_CLICK = 'boilerplate/boilerplate/CAPTURE_GLOBAL_CLICK';

// Action Creators
var closeHistory = (0, _reduxActions.createAction)(CLOSE_HISTORY);
exports.closeHistory = closeHistory;
var captureGlobalClick = (0, _reduxActions.createAction)(CAPTURE_GLOBAL_CLICK);

// Reducer
exports.captureGlobalClick = captureGlobalClick;
var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _connectedReactRouter.LOCATION_CHANGE, function (state, action) {
  var currentTime = new Date().getTime();
  var lastUrl = (0, _last2["default"])(state.urlHistory);
  var previosTime = lastUrl ? lastUrl.time : 0;
  var pathname = action.payload.location.pathname;
  if (lastUrl && lastUrl.url === pathname) {
    return state;
  }
  var urlHistory = _toConsumableArray(state.urlHistory);
  if (currentTime - previosTime < limitTime) {
    urlHistory.pop();
  } else if (urlHistory.length > 0) {
    // Save pageVisit event
    var last = (0, _last2["default"])(urlHistory);
    (0, _cccisdLaravelEventlog.addEvent)({
      eventType: 'pageVisit',
      url: last.url,
      duration: currentTime - last.time
    });
  }
  urlHistory.push({
    url: pathname,
    time: currentTime
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    urlHistory: urlHistory
  });
}), _defineProperty(_handleActions, CLOSE_HISTORY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    urlHistory: [].concat(_toConsumableArray(state.urlHistory), [{
      url: 'some_fake_url',
      time: action.payload
    }])
  });
}), _defineProperty(_handleActions, CAPTURE_GLOBAL_CLICK, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    globalClickCaptured: true
  });
}), _handleActions), initialState);
exports["default"] = _default;